import script from "./DiagonallyCutImage.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagonallyCutImage.vue?vue&type=script&setup=true&lang=js"

import "./DiagonallyCutImage.vue?vue&type=style&index=0&id=15cd65b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15cd65b9"]])

export default __exports__